export const CONFIGURABLE_NAME_ADD_TO_CART = 'add_to_cart';

function generateAddToCartConfigurable({ enabled, text, textColor, backgroundColor }) {
  if (!enabled) return undefined;

  const productCodeField = 'pk';

  const configurable = {
    type: 'flyoutCta',
    name: CONFIGURABLE_NAME_ADD_TO_CART,
    text,
    textColor,
    backgroundColor,

    conditions: {
      // the show conditon (optional) lets a 'flyoutCta' configurable to be shown only when the condition is met. In this case, when the product has a product code (not falsy)
      show: {
        product: productCodeField,
      },
    },

    onClick: {
      fields: {
        product: {
          // the onClick.fields.product indicates which fields to project from the product entity from NEXT and with which names
          product_name: 'name',
          product_code: productCodeField,
          full_price: 'price.full',
          discounted_price: 'price.discounted',
        },
      },
    },

    ctaEvent: {
      type: 'add-to-cart',
    },
  };

  try {
    return btoa(JSON.stringify(configurable));
  } catch (e) {
    console.error('Unable to serialize configurables', configurable, e);
    return undefined;
  }
}

function handleAddToCart(configurables, { query, addToCart }) {
  const enabled = Boolean(query.add_to_cart?.enabled === 'true' && addToCart?.enabled);

  if (!enabled) return;

  const addToCartParams = {
    enabled,
    text: query.add_to_cart?.button?.text ?? addToCart.text,
    textColor: query.add_to_cart?.button?.textColor ?? addToCart.textColor,
    backgroundColor: query.add_to_cart?.button?.backgroundColor ?? addToCart.backgroundColor,
  };

  configurables.push(generateAddToCartConfigurable(addToCartParams));
}

export function generateConfigurablesQueryParam(params) {
  const configurables = [];

  handleAddToCart(configurables, params);

  return configurables;
}
